import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const RealProperty = ({ end }) => {
	
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, realProperty: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}

	const steps = [
		{
			target: '.realPropertyFirstStep',
			title: "First Real Property",
			content: 'Create your first listing of property for rent or sale.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.realPropertySecondStep',
			title: "Main Information",
			content: 'Provide main information of your property.',
			disableBeacon: true,
			placement: "bottom",
			path: '/setup/real-property/customize?type=property-listing&method=create'
		},
		{
			target: '.realPropertyThirdStep',
			title: "Property Images",
			content: 'Upload images of your property.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.realPropertyFourthStep',
			title: "Property Location",
			content: 'Provide where the property is located.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.realPropertyFifthStep',
			title: "Other Information",
			content: 'Provide other information for your property.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.realPropertySixthStep',
			title: "Cancel Real Property Setup",
			content: "Cancel what you've input for your property.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.realPropertySeventhStep',
			title: "Save Real Property",
			content: "Save your real property setup.",
			disableBeacon: true,
			placement: "top"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.realPropertyFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.realProperty)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="realProperty" 
			featureName="setup"
		/>
	);
}
